import React from "react";
import Card from "../CardDashboard/Card";
import { useLanguage } from "../LangTranslation/LanguageContext";
import SkeletonCard from "./SkeletonCard";

const AnalyticsCards = ({ isLoading, data = [] }) => {
  const { language, translations } = useLanguage();

  const cardsData = [
    {
      title: "Active Users",
      value: data?.total_active_users || "0",
    },
    {
      title: "New Users",
      value: data?.new_users || "0",
    },
    {
      title: "Average User Time",
      value: data?.avg_engagement_time_per_user || "0s",
    },
    {
      title: "Event Count",
      value: data?.event_count || "0",
    },
  ];

  return (
    <div className="row px-2">
      {isLoading
        ? cardsData.map((_, index) => (
            <div className="col-xl-3 col-lg-6 mb-3 " key={index}>
              <SkeletonCard count={4} />
            </div>
          ))
        : cardsData.map((card, index) => (
            <div className="col-xl-3 col-lg-6 mb-3 " key={index}>
              <Card title={card.title} value={card.value} />
            </div>
          ))}
    </div>
  );
};

export default AnalyticsCards;
